import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import styled from 'styled-components';
import { useIsTruncated } from '../../hooks/use_is_truncated.js';
import { spacing1x } from '../../styles/spacing.js';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var defaultElement = "label";
var Label = styled.label.withConfig({
  displayName: "FormFieldLabel__Label",
  componentId: "sc-2c9n9v-0"
})(["&&{color:", ";text-overflow:ellipsis;white-space:nowrap;overflow:hidden;font-size:14px;font-weight:normal;line-height:calc(", " * 8);}"], function (props) {
  return props.theme.neutralColors.charcoal;
}, spacing1x);
var AndornmentWrapper = styled.div.withConfig({
  displayName: "FormFieldLabel__AndornmentWrapper",
  componentId: "sc-2c9n9v-1"
})(["&&{margin-inline-start:", ";}"], spacing1x);
var LabelWrapper = styled.div.withConfig({
  displayName: "FormFieldLabel__LabelWrapper",
  componentId: "sc-2c9n9v-2"
})(["&&{min-width:0%;display:flex;align-items:baseline;", ";}"], function (props) {
  return props.$required && "\n        &:after {\n            content: \"*\";\n            color: ".concat(props.theme.alertColors.error, ";\n            font-size: 12px;\n            margin-inline-start: ").concat(spacing1x, ";\n            vertical-align: middle;\n        }\n    ");
});
var FormFieldLabel = /*#__PURE__*/React.forwardRef(function FormLabel(_ref, ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? defaultElement : _ref$as,
    children = _ref.children,
    className = _ref.className,
    endAdornment = _ref.endAdornment,
    hideLabel = _ref.hideLabel,
    htmlFor = _ref.htmlFor,
    id = _ref.id,
    required = _ref.required,
    tooltipProps = _ref.tooltipProps;
  var _useIsTruncated = useIsTruncated(children),
    _useIsTruncated2 = _slicedToArray(_useIsTruncated, 2),
    labelRef = _useIsTruncated2[0],
    truncated = _useIsTruncated2[1];
  var labelProps = {
    htmlFor: htmlFor,
    id: id,
    ref: labelRef,
    as: as,
    children: children
  };
  if (as === "legend") delete labelProps.htmlFor;
  var label = /*#__PURE__*/jsx(Label, _objectSpread({}, labelProps));
  if (hideLabel) return /*#__PURE__*/jsx(VisuallyHidden, {
    children: label
  });
  return /*#__PURE__*/jsxs(LabelWrapper, {
    $required: required,
    ref: ref,
    className: className,
    children: [/*#__PURE__*/jsx(Tooltip, _objectSpread(_objectSpread({
      content: truncated ? children : void 0
    }, tooltipProps), {}, {
      children: label
    })), endAdornment && /*#__PURE__*/jsx(AndornmentWrapper, {
      children: endAdornment
    })]
  });
});
FormFieldLabel.displayName = "FormFieldLabel";

export { FormFieldLabel, LabelWrapper };
